import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export class BaseService<T> {
  constructor(protected http: HttpClient, protected backUrl: string) {}

  get(): Observable<T[]> {
    return this.http.get<T[]>(this.backUrl);
  } 
  
  getById(id: any): Observable<T> {
    return this.http.get<T>(`${this.backUrl}/${id}`);
  }  
  
  query(filter: string): Observable<T[]> {
    return this.http.get<T[]>(`${this.backUrl}/query?${filter}`);
  }

  post(model: T): Observable<any> {
    return this.http.post(this.backUrl, model);
  }

  put(model: T & { id: number }): Observable<any> {
    return this.http.put(`${this.backUrl}/${model.id}`, model);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.backUrl}/${id}`);
  }
}
